import React from 'react'

const Faq = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/faq',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='matrix(1, 0, 0, 1, 3.5, 1)'
    >
      <g transform='matrix(1, 0, 0, 1, 4.328096, 6.818465)'>
        <path
          d='M 0 2.161 C 0 0.942 1.016 -0.049 2.235 0.002 C 3.378 0.027 4.317 0.967 4.343 2.11 C 4.368 3.024 3.81 3.837 3.022 4.167 C 2.514 4.396 2.16 4.853 2.16 5.411'
          stroke={secondaryColor}
          strokeWidth='1.5'
          strokeLinecap='round' />
        <circle
          cx='2.133'
          cy='7.911'
          r='1'
          fill={secondaryColor}
          strokeWidth='0' />
      </g>
      <g
        stroke={primaryColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.19999993'>
        <path
          d='M 13 13 L 8.333 18 L 0.933 18 C 0.449 18 0 17.481 0 17 L 0 1 C 0 0.52 0.449 0 0.933 0 L 12.067 0 C 12.551 0 13 0.52 13 1 L 13 13 Z'
          transform='matrix(-1, 0, 0, -1, 13, 18)' />
        <polygon
          points='5 0 0 0 0 5'
          transform='matrix(-1, 0, 0, -1, 5, 5)' />
      </g>
    </g>
  </svg>
)

export default Faq
